import { useState } from 'react';

import Tabs from '@cartwhl/ui/molecules/Tabs';

import { EXPORT_TYPES } from 'stores/animationGenerationStore';

import DownloadFile from './DownloadFile';
import DownloadImage from './DownloadImage';
import TabItem from './TabItem';

interface PoseDownloadProps {
  handleOpenChange: (open: boolean) => void;
}

export default function PoseDownload({ handleOpenChange }: PoseDownloadProps) {
  const [downloadFormat, setDownloadFormat] = useState<EXPORT_TYPES>(
    EXPORT_TYPES.BVH,
  );

  return (
    <Tabs
      tabListClassName="-mx-4 lg:mx-0 px-4 lg:px-0"
      tabs={[
        {
          value: EXPORT_TYPES.PNG,
          label: <TabItem>Image</TabItem>,
          content: <DownloadImage handleOpenChange={handleOpenChange} />,
        },
        {
          value: EXPORT_TYPES.BVH,
          label: <TabItem>BVH</TabItem>,
          content: (
            <DownloadFile
              tab={EXPORT_TYPES.BVH}
              downloadFormat={downloadFormat}
              setDownloadFormat={setDownloadFormat}
              handleOpenChange={handleOpenChange}
            />
          ),
        },
        {
          value: EXPORT_TYPES.FBX_MAYA,
          label: <TabItem>FBX</TabItem>,
          content: (
            <DownloadFile
              tab={EXPORT_TYPES.FBX_MAYA}
              downloadFormat={downloadFormat}
              setDownloadFormat={setDownloadFormat}
              handleOpenChange={handleOpenChange}
            />
          ),
        },
        {
          value: EXPORT_TYPES.GLB,
          label: <TabItem>glTF</TabItem>,
          content: (
            <DownloadFile
              tab={EXPORT_TYPES.GLB}
              downloadFormat={downloadFormat}
              setDownloadFormat={setDownloadFormat}
              handleOpenChange={handleOpenChange}
            />
          ),
        },
        {
          value: EXPORT_TYPES.MA,
          label: <TabItem isPro>Maya</TabItem>,
          content: (
            <DownloadFile
              tab={EXPORT_TYPES.MA}
              downloadFormat={downloadFormat}
              setDownloadFormat={setDownloadFormat}
              handleOpenChange={handleOpenChange}
            />
          ),
        },
      ]}
    />
  );
}
